import React from 'react';
import Layout from '../../components/Layout';
import Theme from './Theme';
import { getWorkspaceWidgetCount } from '../../data/models/Theme/themeJSONHelper';
import getMoreThemes from "./more/getMoreThemes";

async function action({ params, fetch }) {
  const resp = await fetch('/graphql', {
    body: JSON.stringify({
      query: '{theme(id:"' + params.id + '"){id,title,description,installs,author,appJSON,status,access,workspace}}',
    }),
  });
  const { data } = await resp.json();
  if (!data || !data.theme) throw new Error('Failed to load the theme.');

  let theme = data.theme;
  let appJSON = JSON.parse(theme.appJSON);

  let title = theme.title;
  let moreThemes = await getMoreThemes(fetch);

  return {
    chunks: ['theme'],
    title,
    heads: [
      <meta property={"og:image"} content={`https://new-tab.studio/screenshots/1200/${theme.id}-${theme.workspace}.jpg`} />,
      <meta property={"og:description"} content={theme.description && theme.description.trim().length ? theme.description : 'Make your new tab beatiful and share with friends'} />
    ],
    component: (
      <Layout>
        <Theme theme={theme} moreThemes={moreThemes} slug={params.id} appJSON={appJSON} workspaces={Object.keys(getWorkspaceWidgetCount(appJSON))} data={data.news} />
      </Layout>
    ),
  };
}

export default action;
